<template>
  <addon-layout
    title="Parcours TUT’TOP"
    subtitle="Aperçu professeur de la pièce jointe Classroom."
    :loading="loading"
    :error="error"
  >
    <section
      v-if="needsGoogleAuth"
      class="teacher-card"
    >
      <h2>Se connecter avec Google</h2>
      <p>Confirmez le compte professeur actuellement ouvert dans Classroom.</p>
      <google-sign-in-button
        @click="connectGoogle"
      />
    </section>
    <section
      v-else-if="attachment"
      class="teacher-card"
    >
      <span class="eyebrow">Parcours attaché</span>
      <h2>{{ attachment.title }}</h2>
      <p>Les élèves obtiennent chacun un parcours adaptatif et leur score est synchronisé sur 100.</p>
    </section>
    <section
      v-else-if="!error"
      class="teacher-card"
    >
      Cette pièce jointe TUT’TOP est introuvable ou désactivée.
    </section>
    <button
      v-if="!needsGoogleAuth"
      type="button"
      class="disconnect"
      @click="disconnect"
    >
      Révoquer l’accès Google de TUT’TOP
    </button>
  </addon-layout>
</template>

<script>
import {
  authorize,
  client,
  clearAddonSession,
  hasAddonSession,
  launchContext,
} from '@/services/googleClassroomAddon'
import AddonLayout from './AddonLayout.vue'
import GoogleSignInButton from './GoogleSignInButton.vue'

export default {
  name: 'GoogleClassroomAddonTeacherView',
  components: { AddonLayout, GoogleSignInButton },
  data() {
    return {
      loading: true,
      error: '',
      attachment: null,
      needsGoogleAuth: !hasAddonSession(),
    }
  },
  async created() {
    if (hasAddonSession()) await this.initialize()
    else this.loading = false
  },
  methods: {
    async initialize() {
      this.loading = true
      this.error = ''
      try {
        const response = await client.post('/context', launchContext(this.$route))
        if (response.data.role !== 'teacher') throw new Error('Cette vue est réservée au professeur.')
        this.attachment = response.data.attachment
        this.needsGoogleAuth = false
      } catch (error) {
        this.error = error.response?.data?.error || error.message
        if (error.response && error.response.status === 401) this.needsGoogleAuth = true
      } finally {
        this.loading = false
      }
    },
    async connectGoogle() {
      this.loading = true
      this.error = ''
      try {
        await authorize(this.$route)
        await this.initialize()
      } catch (error) {
        this.error = error.response?.data?.error || error.message
        this.loading = false
      }
    },
    async disconnect() {
      try {
        await client.delete('/disconnect')
        clearAddonSession()
        this.attachment = null
        this.error = 'Accès Google révoqué. Rechargez la fenêtre pour vous reconnecter.'
      } catch (error) {
        this.error = error.response?.data?.error || error.message
      }
    },
  },
}
</script>

<style scoped>
.teacher-card {
  padding: 24px;
  border: 1px solid #dbe3ef;
  border-radius: 14px;
  background: white;
}
.eyebrow {
  color: #635bff;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}
h2 { margin: 8px 0; }
.disconnect {
  margin-top: 18px;
  padding: 8px 0;
  border: 0;
  background: transparent;
  color: #64748b;
  text-decoration: underline;
}
</style>
